import { defineComponent as _defineComponent } from 'vue'
import { UserRoles } from "@/enums/UserRoles";
  
  import LottrackrPoweredIcon from "@/components/ui/LottrackrPoweredIcon.vue";
  import { MASTERPLAN_STATUS_COLORS } from "@/v2/helpers/masterplanLotStatus";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'MapSideLegend',
  props: {
    isEstateMap: Boolean,
    role: { type: String, default: () => UserRoles.LANDOWNER },
  },
  setup(__props, { expose: __expose }) {
  __expose();

  const C = MASTERPLAN_STATUS_COLORS;

  const props = __props;

const __returned__ = { C, props, get UserRoles() { return UserRoles }, LottrackrPoweredIcon, get MASTERPLAN_STATUS_COLORS() { return MASTERPLAN_STATUS_COLORS } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})